//Import required modules
import React from 'react';
import PropTypes from 'prop-types'
import { updatePalette, copyColorToClipboard } from '../../store/actions';

const UserCircle = ({id, selected, cx, cy, radius, color}, {store}) =>
{
    let userWindow = store.getState().userWindow;
    let theme = store.getState().theme
    return (
    <circle className={theme}
        cx={cx} 
        cy={cy} 
        r={radius} 
        fill={color}
        onClick={(event) => 
        {
            store.dispatch(updatePalette(id, color, selected, userWindow))
            store.dispatch(copyColorToClipboard(color))

            // //Change the color clip position to the position where user clicked
            // var theThing = document.querySelector("#colorClipDiv");
            // theThing.style.left = event.clientX + "px";
            // theThing.style.top = event.clientY + "px";
        }}>
    </circle>
    )
}

UserCircle.contextTypes = {
    store: PropTypes.object
}

export default UserCircle;

